// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import RationCardDetailsActionType from './ration-card-details.types';
import {
	updateRationCardSuccess,
	updateRationCardFailure,
	updateRationCardResponseChanged,
} from './ration-card-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { rationCardUpdateDetails } from './ration-card-details.service';

/** ***************** Ration Card Details Update Start ************************/
export function* updateRationCardIdDetails({ payload }: any) {
	try {
		const key = 'updateRationCardID';
		const {
			companyID,
			databaseName,
			memberID,
			memberRationCardFrontImg,
			memberRationCardBackImg,
			proofType,
			docType,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberRationCardFrontImg: memberRationCardFrontImg,
			MemberRationCardBackImg: memberRationCardBackImg,
			ProofType: proofType,
			DocumantType: docType,
			OfficerID: userID,
			Secratekey: key,
		};

		const rationCardData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rationCardUpdateDetails, rationCardData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateRationCardFailure(responseData.data));
		} else {
			yield put(updateRationCardSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateRationCardFailure(error));
	}
}

export function* updateRationCardDetailsResponseClear() {
	yield put(updateRationCardResponseChanged());
}

export function* onRationCardDetailsUpdateStart() {
	yield takeLatest(
		RationCardDetailsActionType.UPDATE_RATION_CARD_START,
		updateRationCardIdDetails,
	);
}

export function* onRationCardDetailsUpdateResponseRest() {
	yield takeLatest(
		RationCardDetailsActionType.UPDATE_RATION_CARD_RESPONSE_REST_START,
		updateRationCardDetailsResponseClear,
	);
}
/** ***************** Ration Card Details Update End ************************/

export function* rationCardDetailsSaga() {
	yield all([call(onRationCardDetailsUpdateStart), call(onRationCardDetailsUpdateResponseRest)]);
}
